import { DocumentTextIcon } from "@heroicons/react/24/outline";

import type { FeatureMetadata } from "../../../feature.types";
import {
  buildCrudPermissions,
  createLazyPlaceholderPage,
  permissionId,
} from "../../../shared/featureFactories";

function buildViewOnlyPermissions(action: string) {
  return { view: action, create: action, edit: action, delete: action };
}

export const AccountStatementFeature: FeatureMetadata = {
  id: "accounts-account-statement",
  moduleName: "feesFinance",
  navigation: {
    label: "Account Statement",
    path: "/accounts/account-statement",
    icon: DocumentTextIcon,
    order: 4,
    parentId: "accounts",
  },
  route: {
    path: "/accounts/account-statement",
    element: createLazyPlaceholderPage(
      "Account Statement",
      "Navigation placeholder backed by the shared finance tables in the unified Payments module.",
    ),
  },
  permissions: buildCrudPermissions(
    "FeeFinance",
    "Accounts",
    buildViewOnlyPermissions(permissionId("FeeFinance", "Accounts", "accountStatement")),
  ),
  readiness: "live",
};
